export default __webpack_public_path__ + "static/Group 148461-ad3161b4ef9a4ca3ae57854dc663ddca.png";